import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (F90N)
// ============================================================

export interface F90N {
  f90n_01: string;           // 單號 (PK)
  f90n_11: string;           // 員工代號
  f90n_12: string | null;    // 申請日期
  f90n_13: string;           // 停職說明
  f90n_14: string | null;    // 停職開始日
  f90n_15: string | null;    // 停職結束日
  f90n_21: string;           // 部門代號
  f90n_22: string;           // 職稱代號
  f90n_23: string | null;    // 到職日
  f90n_56: string;           // 手續完成勾選
  f90n_57: string;           // 人事主管代號
  f90n_58: string | null;    // 確認日期
  f90n_61: string;           // 主管核准 Y/N/空白
  f90n_62: string;           // 主管核准人代號
  f90n_63: string | null;    // 主管核准日期
  f90n_64: string;           // 主管核准說明
  f90n_66: string;           // 人事主管核准 Y/N/空白
  f90n_67: string;           // 人事主管核准人代號
  f90n_68: string | null;    // 人事主管核准日期
  f90n_69: string;           // 人事主管核准說明
  f90n_71: string;           // 副總核准 Y/N/空白
  f90n_72: string;           // 副總核准人代號
  f90n_73: string | null;    // 副總核准日期
  f90n_74: string;           // 副總核准說明
  f90n_76: string;           // 總經理核准 Y/N/空白
  f90n_77: string;           // 總經理核准人代號
  f90n_78: string | null;    // 總經理核准日期
  f90n_79: string;           // 總經理核准說明
  f90n_80: string;           // 狀態
  f90n_87: string;           // 備用欄位
  f90n_88: string | null;    // 備用日期
  f90n_91: string;           // 建立者
  f90n_92: string | null;    // 建立時間
  f90n_93: string;           // 更新者
}

// ============================================================
// Request / Response types
// ============================================================

export interface P9209ListResponse {
  data: F90N[];
  total: number;
  page: number;
  size: number;
}

export interface P9209CreateRequest {
  master: Partial<F90N>;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const p9209Api = {
  async list(page = 1, size = 20): Promise<P9209ListResponse> {
    const res = await apiClient.get('/api/p9209', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<F90N> {
    const res = await apiClient.get(`/api/p9209/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: P9209CreateRequest): Promise<F90N> {
    const res = await apiClient.post('/api/p9209', data);
    return res.data;
  },

  async update(id: string, data: P9209CreateRequest): Promise<F90N> {
    const res = await apiClient.put(`/api/p9209/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/p9209/${encodeURIComponent(id)}`);
  },

  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/p922a/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
